module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tch-ranking-page"
  }, [_c('div', {
    ref: "exportArea",
    staticClass: "export-sheet"
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-glow hero-glow-a"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-glow hero-glow-b"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hero-stats"
  }, _vm._l((_vm.heroStats), function(item) {
    return _c('div', {
      key: item.label,
      staticClass: "hero-stat"
    }, [_c('div', {
      staticClass: "hero-stat-value"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('div', {
      staticClass: "hero-stat-label"
    }, [_vm._v(_vm._s(item.label))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "rank-toolbar export-skip"
  }, [_c('div', {
    staticClass: "seg"
  }, _vm._l((_vm.periodOptions), function(item) {
    return _c('a', {
      key: item.value,
      staticClass: "seg-item",
      class: {
        'is-active': _vm.periodType === item.value
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onPeriodTypeChange(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tool-field"
  }, [_c('span', {
    staticClass: "tool-label"
  }, [_vm._v("日期")]), _vm._v(" "), _c('Date-picker', {
    staticClass: "range-picker",
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "clearable": false,
      "transfer": "",
      "placeholder": "选择日期范围"
    },
    on: {
      "on-change": _vm.onDateRangeChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tool-field"
  }, [_c('span', {
    staticClass: "tool-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('Select', {
    staticClass: "adviser-select",
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onFilterChange
    },
    model: {
      value: (_vm.studyAdviserId),
      callback: function($$v) {
        _vm.studyAdviserId = _vm._n($$v)
      },
      expression: "studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n        ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tool-field"
  }, [_c('span', {
    staticClass: "tool-label"
  }, [_vm._v("开课时间")]), _vm._v(" "), _c('Date-picker', {
    staticClass: "range-picker",
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "transfer": "",
      "placeholder": "不限"
    },
    on: {
      "on-change": _vm.onFilterChange
    },
    model: {
      value: (_vm.openCourseRange),
      callback: function($$v) {
        _vm.openCourseRange = $$v
      },
      expression: "openCourseRange"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tool-field"
  }, [_c('span', {
    staticClass: "tool-label"
  }, [_vm._v("老师性别")]), _vm._v(" "), _c('Select', {
    staticClass: "sex-select",
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onFilterChange
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = _vm._n($$v)
      },
      expression: "sex"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tool-field"
  }, [_c('span', {
    staticClass: "tool-label"
  }, [_vm._v("榜单")]), _vm._v(" "), _c('Select', {
    staticClass: "sex-select",
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.boardFilter),
      callback: function($$v) {
        _vm.boardFilter = $$v
      },
      expression: "boardFilter"
    }
  }, _vm._l((_vm.boardFilterOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label) + "\n        ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tool-actions"
  }, [_c('a', {
    staticClass: "rule-link",
    class: {
      'is-busy': _vm.exportLoading
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.exportToImage
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-download-outline"
    }
  }), _vm._v(" " + _vm._s(_vm.exportLoading ? '导出中' : '导出图片') + "\n      ")], 1), _vm._v(" "), _c('a', {
    staticClass: "rule-link",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.ruleModal = true
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-outline"
    }
  }), _vm._v(" 计分规则\n      ")], 1)])]), _vm._v(" "), (_vm.pageLoading) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPodium && _vm.podium.length) ? _c('div', {
    staticClass: "stage"
  }, [_c('div', {
    staticClass: "stage-beam stage-beam-l"
  }), _vm._v(" "), _c('div', {
    staticClass: "stage-beam stage-beam-c"
  }), _vm._v(" "), _c('div', {
    staticClass: "stage-beam stage-beam-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "stage-title"
  }, [_vm._v("TOP 3 · 本期之星")]), _vm._v(" "), _c('div', {
    staticClass: "podium"
  }, _vm._l((_vm.podium), function(row, idx) {
    return _c('div', {
      key: row.tchId,
      staticClass: "podium-col",
      class: 'is-rank-' + row.rank,
      style: ({
        animationDelay: (idx * 0.12) + 's'
      })
    }, [_c('div', {
      staticClass: "podium-person"
    }, [(row.rank === 1) ? _c('div', {
      staticClass: "crown"
    }, [_vm._v("♛")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "avatar",
      class: _vm.medalClass(row.rank)
    }, [_c('span', [_vm._v(_vm._s(_vm.initials(row.tchName)))])]), _vm._v(" "), _c('div', {
      staticClass: "medal medal-podium",
      class: _vm.medalClass(row.rank)
    }, [_c('i', {
      staticClass: "medal-ribbon medal-ribbon-l"
    }), _vm._v(" "), _c('i', {
      staticClass: "medal-ribbon medal-ribbon-r"
    }), _vm._v(" "), _c('span', {
      staticClass: "medal-core"
    }, [_vm._v(_vm._s(row.rank))])]), _vm._v(" "), _c('a', {
      staticClass: "podium-name",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_vm._v(_vm._s(row.tchName || '—'))]), _vm._v(" "), _c('div', {
      staticClass: "podium-id"
    }, [_vm._v("ID " + _vm._s(row.tchId) + " · " + _vm._s(row.studyAdviserName || '未分配运营'))]), _vm._v(" "), _c('div', {
      staticClass: "podium-score"
    }, [_vm._v("\n            " + _vm._s(_vm.formatScore(row.totalScore))), _c('span', {
      staticClass: "podium-score-unit"
    }, [_vm._v("分")])]), _vm._v(" "), _c('div', {
      staticClass: "podium-bars"
    }, _vm._l((_vm.podiumMetrics), function(metric) {
      return _c('div', {
        key: metric.value,
        staticClass: "pbar"
      }, [_c('span', {
        staticClass: "pbar-label"
      }, [_vm._v(_vm._s(metric.title))]), _vm._v(" "), _c('span', {
        staticClass: "pbar-track"
      }, [_c('i', {
        staticClass: "pbar-fill",
        class: _vm.gradeLevel(row[metric.grade]),
        style: ({
          width: _vm.gradeWidth(row[metric.grade])
        })
      })]), _vm._v(" "), _c('span', {
        staticClass: "pbar-value"
      }, [_vm._v(_vm._s(_vm.displayValue(row[metric.value])))])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "pedestal"
    }, [_c('span', {
      staticClass: "pedestal-num"
    }, [_vm._v(_vm._s(row.rank))]), _vm._v(" "), _c('span', {
      staticClass: "pedestal-tag"
    }, [_vm._v(_vm._s(_vm.rankTitle(row.rank)))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showChallengers) ? [_vm._m(1), _vm._v(" "), (_vm.challengers.length) ? _c('div', {
    staticClass: "card-grid"
  }, _vm._l((_vm.challengers), function(row, idx) {
    return _c('div', {
      key: 'c-' + row.tchId,
      staticClass: "rank-card",
      class: _vm.scoreLevel(row.totalScore),
      style: ({
        animationDelay: Math.min(idx, 12) * 0.04 + 's'
      })
    }, [_c('div', {
      staticClass: "rank-card-top"
    }, [_c('div', {
      staticClass: "medal medal-sm",
      class: _vm.medalClass(row.rank)
    }, [_c('i', {
      staticClass: "medal-ribbon medal-ribbon-l"
    }), _vm._v(" "), _c('i', {
      staticClass: "medal-ribbon medal-ribbon-r"
    }), _vm._v(" "), _c('span', {
      staticClass: "medal-core"
    }, [_vm._v(_vm._s(row.rank))])]), _vm._v(" "), _c('a', {
      staticClass: "rank-avatar",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.initials(row.tchName)))])]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-who"
    }, [_c('a', {
      staticClass: "rank-card-name",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_vm._v("\n            " + _vm._s(row.tchName || '—') + "\n            "), (row.rank <= 10) ? _c('span', {
      staticClass: "top10"
    }, [_vm._v("TOP 10")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-sub"
    }, [_vm._v("ID " + _vm._s(row.tchId) + " · " + _vm._s(row.studyAdviserName || '未分配运营'))]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-sub"
    }, [_vm._v("开课 " + _vm._s(_vm.formatOpenCourse(row.openCourseTime)) + " · 有课 " + _vm._s(row.lessonCount || 0) + " 节")])]), _vm._v(" "), _c('div', {
      staticClass: "score-ring",
      style: (_vm.ringStyle(row.totalScore))
    }, [_c('div', {
      staticClass: "score-ring-inner"
    }, [_c('div', {
      staticClass: "score-ring-num"
    }, [_vm._v(_vm._s(_vm.formatScoreShort(row.totalScore)))]), _vm._v(" "), _c('div', {
      staticClass: "score-ring-unit"
    }, [_vm._v("分")])])])]), _vm._v(" "), _c('div', {
      staticClass: "strip"
    }, _vm._l((_vm.metrics), function(metric) {
      return _c('span', {
        key: metric.value,
        staticClass: "strip-seg",
        class: _vm.gradeLevel(row[metric.grade]),
        style: ({
          flex: metric.weight
        }),
        attrs: {
          "title": _vm.metricTip(row, metric)
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "strip-caption"
    }, [_c('span', [_vm._v("10 项指标（宽度 = 权重）")]), _vm._v(" "), _c('a', {
      staticClass: "toggle",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.toggle(row.tchId)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.expanded[row.tchId] ? '收起' : '明细') + "\n          "), _c('Icon', {
      attrs: {
        "type": _vm.expanded[row.tchId] ? 'ios-arrow-up' : 'ios-arrow-down'
      }
    })], 1)]), _vm._v(" "), (_vm.expanded[row.tchId]) ? _c('div', {
      staticClass: "metric-grid"
    }, _vm._l((_vm.metrics), function(metric) {
      return _c('div', {
        key: metric.value,
        staticClass: "metric-chip",
        attrs: {
          "title": _vm.metricTip(row, metric)
        }
      }, [_c('div', {
        staticClass: "metric-chip-label"
      }, [_vm._v(_vm._s(metric.title)), _c('em', [_vm._v(_vm._s(metric.weight))])]), _vm._v(" "), _c('div', {
        staticClass: "metric-chip-value"
      }, [_vm._v(_vm._s(_vm.displayValue(row[metric.value])))]), _vm._v(" "), _c('div', {
        staticClass: "metric-chip-grade",
        class: _vm.gradeLevel(row[metric.grade])
      }, [_vm._v("\n            " + _vm._s(_vm.gradeText(row[metric.grade])) + " · " + _vm._s(_vm.formatScore(row[metric.score])) + "\n          ")])])
    }), 0) : _vm._e()])
  }), 0) : (!_vm.frLoading) ? _c('div', {
    staticClass: "block-empty"
  }, [_vm._v("暂无挑战者")]) : _vm._e(), _vm._v(" "), (_vm.frTotal > _vm.frPageSize) ? _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.frTotal,
      "current": _vm.frPageIndex,
      "page-size": _vm.frPageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onFrPageChange
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showFormalUnranked) ? [_c('div', {
    staticClass: "board-head"
  }, [_c('h2', {
    staticClass: "board-title is-warn"
  }, [_vm._v(_vm._s(_vm.formalUnrankedTitle))]), _vm._v(" "), _c('span', {
    staticClass: "board-legend"
  }, [_vm._v(_vm._s(_vm.formalUnrankedLegend))])]), _vm._v(" "), (_vm.fuRows.length) ? _c('div', {
    staticClass: "card-grid"
  }, _vm._l((_vm.fuRows), function(row) {
    return _c('div', {
      key: 'fu-' + row.tchId,
      staticClass: "rank-card is-out is-unranked"
    }, [_c('div', {
      staticClass: "rank-card-top"
    }, [_c('div', {
      staticClass: "out-badge",
      class: {
        'is-unranked': !_vm.isOutOnly(row)
      }
    }, [_vm._v(_vm._s(_vm.unrankedBadge(row)))]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-who"
    }, [_c('a', {
      staticClass: "rank-card-name",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_vm._v(_vm._s(row.tchName || '—'))]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-sub"
    }, [_vm._v("ID " + _vm._s(row.tchId) + " · " + _vm._s(row.studyAdviserName || '未分配运营'))]), _vm._v(" "), _c('div', {
      staticClass: "out-reason"
    }, [_vm._v(_vm._s(_vm.unrankedReasonText(row)))])]), _vm._v(" "), _c('div', {
      staticClass: "out-score"
    }, [_c('div', {
      staticClass: "out-score-num"
    }, [_vm._v(_vm._s(_vm.formatScore(row.totalScore)))]), _vm._v(" "), _c('div', {
      staticClass: "out-score-label"
    }, [_vm._v("计算分")])])]), _vm._v(" "), _c('div', {
      staticClass: "strip"
    }, _vm._l((_vm.metrics), function(metric) {
      return _c('span', {
        key: metric.value,
        staticClass: "strip-seg",
        class: _vm.gradeLevel(row[metric.grade]),
        style: ({
          flex: metric.weight
        }),
        attrs: {
          "title": _vm.metricTip(row, metric)
        }
      })
    }), 0)])
  }), 0) : (!_vm.fuLoading) ? _c('div', {
    staticClass: "block-empty"
  }, [_c('div', [_vm._v(_vm._s(_vm.formalUnrankedEmpty))]), _vm._v(" "), (_vm.boardFilter === 'out') ? _c('div', {
    staticClass: "block-empty-hint"
  }, [_vm._v("可翻页或调整统计周期后再试")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.fuTotal > _vm.fuPageSize) ? _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.fuTotal,
      "current": _vm.fuPageIndex,
      "page-size": _vm.fuPageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onFuPageChange
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showRookie) ? [_c('div', {
    staticClass: "rookie-box"
  }, [_vm._m(2), _vm._v(" "), (_vm.rrRows.length) ? _c('div', {
    staticClass: "card-grid"
  }, _vm._l((_vm.rrRows), function(row, idx) {
    return _c('div', {
      key: 'rr-' + row.tchId,
      staticClass: "rank-card is-rookie",
      class: _vm.scoreLevel(row.totalScore),
      style: ({
        animationDelay: Math.min(idx, 12) * 0.04 + 's'
      })
    }, [_c('div', {
      staticClass: "rank-card-top"
    }, [_c('div', {
      staticClass: "medal medal-sm medal-rookie"
    }, [_c('span', {
      staticClass: "medal-core"
    }, [_vm._v("新" + _vm._s(row.rank || (idx + 1)))])]), _vm._v(" "), _c('a', {
      staticClass: "rank-avatar is-rookie",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.initials(row.tchName)))])]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-who"
    }, [_c('a', {
      staticClass: "rank-card-name",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_vm._v("\n              " + _vm._s(row.tchName || '—') + "\n              "), _c('span', {
      staticClass: "rookie-tag"
    }, [_vm._v("新锐")])]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-sub"
    }, [_vm._v("ID " + _vm._s(row.tchId) + " · " + _vm._s(row.studyAdviserName || '未分配运营'))]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-sub"
    }, [_vm._v("开课 " + _vm._s(_vm.formatOpenCourse(row.openCourseTime)) + " · 有课 " + _vm._s(row.lessonCount || 0) + " 节")])]), _vm._v(" "), _c('div', {
      staticClass: "score-ring",
      style: (_vm.ringStyle(row.totalScore))
    }, [_c('div', {
      staticClass: "score-ring-inner"
    }, [_c('div', {
      staticClass: "score-ring-num"
    }, [_vm._v(_vm._s(_vm.formatScoreShort(row.totalScore)))]), _vm._v(" "), _c('div', {
      staticClass: "score-ring-unit"
    }, [_vm._v("分")])])])]), _vm._v(" "), _c('div', {
      staticClass: "strip"
    }, _vm._l((_vm.rookieMetrics), function(metric) {
      return _c('span', {
        key: metric.value,
        staticClass: "strip-seg",
        class: _vm.gradeLevel(row[metric.grade]),
        style: ({
          flex: metric.weight
        }),
        attrs: {
          "title": _vm.metricTip(row, metric)
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "strip-caption"
    }, [_c('span', [_vm._v("10 项指标（新锐权重，宽度 = 权重）")]), _vm._v(" "), _c('a', {
      staticClass: "toggle",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.toggleRookie(row.tchId)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.rookieExpanded[row.tchId] ? '收起' : '明细') + "\n            "), _c('Icon', {
      attrs: {
        "type": _vm.rookieExpanded[row.tchId] ? 'ios-arrow-up' : 'ios-arrow-down'
      }
    })], 1)]), _vm._v(" "), (_vm.rookieExpanded[row.tchId]) ? _c('div', {
      staticClass: "metric-grid"
    }, _vm._l((_vm.rookieMetrics), function(metric) {
      return _c('div', {
        key: metric.value,
        staticClass: "metric-chip",
        attrs: {
          "title": _vm.metricTip(row, metric)
        }
      }, [_c('div', {
        staticClass: "metric-chip-label"
      }, [_vm._v(_vm._s(metric.title)), _c('em', [_vm._v(_vm._s(metric.weight))])]), _vm._v(" "), _c('div', {
        staticClass: "metric-chip-value"
      }, [_vm._v(_vm._s(_vm.displayValue(row[metric.value])))]), _vm._v(" "), _c('div', {
        staticClass: "metric-chip-grade",
        class: _vm.gradeLevel(row[metric.grade])
      }, [_vm._v("\n              " + _vm._s(_vm.gradeText(row[metric.grade])) + " · " + _vm._s(_vm.formatScore(row[metric.score])) + "\n            ")])])
    }), 0) : _vm._e()])
  }), 0) : (!_vm.rrLoading) ? _c('div', {
    staticClass: "block-empty"
  }, [_vm._v("暂无新锐老师")]) : _vm._e(), _vm._v(" "), (_vm.rrTotal > _vm.rrPageSize) ? _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.rrTotal,
      "current": _vm.rrPageIndex,
      "page-size": _vm.rrPageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onRrPageChange
    }
  })], 1) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.showRookieUnranked) ? [_vm._m(3), _vm._v(" "), (_vm.ruRows.length) ? _c('div', {
    staticClass: "card-grid"
  }, _vm._l((_vm.ruRows), function(row) {
    return _c('div', {
      key: 'ru-' + row.tchId,
      staticClass: "rank-card is-out is-unranked is-rookie"
    }, [_c('div', {
      staticClass: "rank-card-top"
    }, [_c('div', {
      staticClass: "out-badge is-unranked"
    }, [_vm._v("未入榜")]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-who"
    }, [_c('a', {
      staticClass: "rank-card-name",
      attrs: {
        "href": "javascript:;",
        "title": (row.tchName || '老师') + ' 详情'
      },
      on: {
        "click": function($event) {
          return _vm.openTchInfo(row)
        }
      }
    }, [_vm._v(_vm._s(row.tchName || '—'))]), _vm._v(" "), _c('div', {
      staticClass: "rank-card-sub"
    }, [_vm._v("ID " + _vm._s(row.tchId) + " · " + _vm._s(row.studyAdviserName || '未分配运营'))]), _vm._v(" "), _c('div', {
      staticClass: "out-reason"
    }, [_vm._v(_vm._s(_vm.unrankedReasonText(row)))])]), _vm._v(" "), _c('div', {
      staticClass: "out-score"
    }, [_c('div', {
      staticClass: "out-score-num"
    }, [_vm._v(_vm._s(_vm.formatScore(row.totalScore)))]), _vm._v(" "), _c('div', {
      staticClass: "out-score-label"
    }, [_vm._v("计算分")])])]), _vm._v(" "), _c('div', {
      staticClass: "strip"
    }, _vm._l((_vm.rookieMetrics), function(metric) {
      return _c('span', {
        key: metric.value,
        staticClass: "strip-seg",
        class: _vm.gradeLevel(row[metric.grade]),
        style: ({
          flex: metric.weight
        }),
        attrs: {
          "title": _vm.metricTip(row, metric)
        }
      })
    }), 0)])
  }), 0) : (!_vm.ruLoading) ? _c('div', {
    staticClass: "block-empty"
  }, [_vm._v("暂无新锐未入榜老师")]) : _vm._e(), _vm._v(" "), (_vm.ruTotal > _vm.ruPageSize) ? _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.ruTotal,
      "current": _vm.ruPageIndex,
      "page-size": _vm.ruPageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onRuPageChange
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showEmpty) ? _c('div', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "empty-trophy"
  }, [_vm._v("🏆")]), _vm._v(" "), _c('div', {
    staticClass: "empty-title"
  }, [_vm._v("本期暂无参评老师")]), _vm._v(" "), _c('div', {
    staticClass: "empty-sub"
  }, [_vm._v("可换个统计周期或放宽筛选后再看四块榜单。")])]) : _vm._e()], 2), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "计分规则",
      "width": "860",
      "footer-hide": ""
    },
    model: {
      value: (_vm.ruleModal),
      callback: function($$v) {
        _vm.ruleModal = $$v
      },
      expression: "ruleModal"
    }
  }, [_c('p', {
    staticClass: "rule-head"
  }, [_vm._v("单项得分 = 权重 × 档位系数（A 1.0 / B 0.8 / C 0.6 / D 0.3 / E 0），满分 100。")]), _vm._v(" "), _c('div', {
    staticClass: "rule-title"
  }, [_vm._v("老老师（正式榜）")]), _vm._v(" "), _c('table', {
    staticClass: "rule-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("指标")]), _vm._v(" "), _c('th', [_vm._v("方向")]), _vm._v(" "), _c('th', [_vm._v("权重")]), _vm._v(" "), _c('th', [_vm._v("A")]), _vm._v(" "), _c('th', [_vm._v("B")]), _vm._v(" "), _c('th', [_vm._v("C")]), _vm._v(" "), _c('th', [_vm._v("D")]), _vm._v(" "), _c('th', [_vm._v("E")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ruleRows), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dir))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.weight))]), _vm._v(" "), _vm._l((item.grades), function(grade, idx) {
      return _c('td', {
        key: idx
      }, [_vm._v(_vm._s(grade))])
    })], 2)
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "rule-foot"
  }, [_vm._v("比较用未四舍五入的原始比值；星级无已评分课节按 B 档；Demo 出席成交率 ≥20% 为 A，其余（含无 Demo 出席）为 B；请假、临时请假、迟到、早退无分母按 A 档；全勤率、上课率无分母按 E 档。同分按有课课节数多者在前，再按老师 ID 升序。入榜门槛只对老老师生效：查询结束日所在自然周的买断课时 ≥ 20 节，与上课率里的买断课时同一算法。")]), _vm._v(" "), _c('div', {
    staticClass: "rule-title is-rookie"
  }, [_vm._v("新锐榜（开课 30 天内）")]), _vm._v(" "), _c('table', {
    staticClass: "rule-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("指标")]), _vm._v(" "), _c('th', [_vm._v("方向")]), _vm._v(" "), _c('th', [_vm._v("权重")]), _vm._v(" "), _c('th', [_vm._v("A")]), _vm._v(" "), _c('th', [_vm._v("B")]), _vm._v(" "), _c('th', [_vm._v("C")]), _vm._v(" "), _c('th', [_vm._v("D")]), _vm._v(" "), _c('th', [_vm._v("E")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rookieRuleRows), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dir))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.weight))]), _vm._v(" "), _vm._l((item.grades), function(grade, idx) {
      return _c('td', {
        key: idx
      }, [_vm._v(_vm._s(grade))])
    })], 2)
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "rule-foot"
  }, [_vm._v("开课时间在查询结束日往前 30 天内（含）的老师进新锐榜，不进正式榜。星级无已评分课节按 B 档；全勤率、上课率无数据按 A 档；请假、临时请假、迟到、早退、退费、返课未发生按 A 档。只用五档；退费 >3 人、返课 >8 记 E 档得 0、不出榜；结束日当周买断 < 20 进「新锐榜未入榜」。")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-title-wrap"
  }, [_c('div', {
    staticClass: "hero-kicker"
  }, [_vm._v("HELLOKID · TEACHER HALL OF FAME")]), _vm._v(" "), _c('h1', {
    staticClass: "hero-title"
  }, [_vm._v("优秀外教排行榜")]), _vm._v(" "), _c('p', {
    staticClass: "hero-sub"
  }, [_vm._v("老老师：在职试用或正式、统计期内有课，结束日当周买断 ≥ 20 节才入榜，退费学生 > 3 或返课时 > 8 出榜不占名次")]), _vm._v(" "), _c('p', {
    staticClass: "hero-sub"
  }, [_vm._v("新老师：开课 30 天内、统计期内有课可入新锐榜；结束日当周买断 < 20 进未入榜；退费/返课"), _c('span', {
    staticClass: "hero-sub-keep"
  }, [_vm._v("不出榜")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board-head"
  }, [_c('h2', {
    staticClass: "board-title"
  }, [_vm._v("挑战者")]), _vm._v(" "), _c('span', {
    staticClass: "board-legend"
  }, [_vm._v("\n      正式有名次（领奖台为 TOP3）；指标色带：\n      "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("A/B\n      "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("C\n      "), _c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("D/E\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board-head"
  }, [_c('h2', {
    staticClass: "board-title is-rookie"
  }, [_vm._v("新锐榜")]), _vm._v(" "), _c('span', {
    staticClass: "board-legend"
  }, [_vm._v("开课 30 天内有名次老师；退费/返课不出榜")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board-head"
  }, [_c('h2', {
    staticClass: "board-title is-warn is-rookie-unranked"
  }, [_vm._v("新锐榜未入榜")]), _vm._v(" "), _c('span', {
    staticClass: "board-legend"
  }, [_vm._v("结束日当周买断<20 不入新锐有名次；名单随上方统计周期变化")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdd0a466","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchTeacherRanking.vue
// module id = 1962
// module chunks = 8